module.exports = __webpack_public_path__ + "img/otto-data@2x.f0b33449.webp";